import styled from 'styled-components';

export const NotFoundWrapper = styled.div``;